export default "__VITE_ASSET__TVrvAj8j__"